'use strict';

var _ = require('lodash');
var UserManagementRolesTransformerFactory = function UserManagementRolesTransformerFactory(DataTransformer, userSecureService, applicationManagementService) {
  var COMPONENTS_HIDDEN_ON_UI = ['external-gm', 'fares-surcharge-upload'];
  function UserManagementRolesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-management-roles-mode';
  }
  UserManagementRolesTransformer.prototype = Object.create(DataTransformer.prototype);
  UserManagementRolesTransformer.constructor = UserManagementRolesTransformer;
  UserManagementRolesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserManagementRolesTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserManagementRolesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserManagementRolesTransformer.prototype.transform = function (data) {
    var results = [];
    var componentApiMap = data.domain.hepList[0].properties.componentApiMap;
    var currentUser = userSecureService.getCurrentUser();
    if (componentApiMap) {
      _.transform(componentApiMap, function (result, item) {
        if (_.get(item, 'visibleTo', false) === 'SystemOwner' && !_.get(currentUser, 'isSystemOwner', false) || !applicationManagementService.isApplicationEnabled(item.application)) {
          return true;
        }
        if (COMPONENTS_HIDDEN_ON_UI.indexOf(item.component) === -1) {
          var newEntity = {
            category: item.category,
            description: item.description,
            information: item.information,
            isViewable: false,
            isEditable: false,
            viewEnabled: !(item.essential || false),
            editEnabled: !(item.essential || false),
            component: item.component,
            parents: item.parents ? item.parents : [],
            parentsRequired: item.parents ? true : false
          };
          newEntity.isViewable = item.essential && true;
          result.push(newEntity);
        }
      }, results);
    }
    return _.uniqBy(results, function (e) {
      return e.component;
    });
  };
  return UserManagementRolesTransformer;
};
UserManagementRolesTransformerFactory.$inject = ['DataTransformerFactory', 'UserSecureService', 'ApplicationManagementService'];
module.exports = UserManagementRolesTransformerFactory;